import styled from 'styled-components'

type TPropsFlex = {
  $gap?: string
  $justifyContent?: string
  $alignItems?: string
}

export const Column = styled.div<TPropsFlex>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || '16px'};
  align-items: ${({ $alignItems: alignItems }) => alignItems || 'center'};
`
export const Row = styled.div<TPropsFlex>`
  display: flex;
  gap: ${({ $gap }) => $gap || '16px'};
  justify-content: ${({ $justifyContent }) => $justifyContent || 'start'};
  align-items: ${({ $alignItems }) => $alignItems || 'center'};
`
